import React from 'react';
import ProgressBar from './ProgressBar';
import { scoreColor, BEHAVIOUR_META } from './diagnosticHelpers';

const BehaviourCard = ({ code, metric }) => {
  const meta = BEHAVIOUR_META[code];
  const raw = metric?.score;
  const measured = raw !== null && raw !== undefined && Number.isFinite(Number(raw));

  // Not measured (e.g. RCI when no difficult questions were presented).
  if (!measured) {
    return (
      <div className="dxr-behaviour-card">
        <div className="dxr-behaviour-head">
          <div>
            <div className="dxr-behaviour-title">{meta.label}</div>
            <div className="dxr-behaviour-code">{code}</div>
          </div>
          <div className="dxr-behaviour-score" style={{ color: '#94a3b8' }}>N/A</div>
        </div>
        <ProgressBar value={0} />
        <p className="dxr-behaviour-meaning">{meta.meaning}</p>
        <div className="dxr-behaviour-callout improve">
          <span className="dxr-callout-tag">Not measured</span>
          <span className="dxr-callout-text">{metric?.description || 'Not enough data in this assessment to measure this metric.'}</span>
        </div>
      </div>
    );
  }

  const score = Math.round(Number(raw));
  const isStrength = score >= 70;
  const color = scoreColor(score);

  return (
    <div className="dxr-behaviour-card">
      <div className="dxr-behaviour-head">
        <div>
          <div className="dxr-behaviour-title">{meta.label}</div>
          <div className="dxr-behaviour-code">{code}</div>
        </div>
        <div className="dxr-behaviour-score" style={{ color }}>{score}<span className="dxr-behaviour-max">/100</span></div>
      </div>

      <ProgressBar value={score} />

      <p className="dxr-behaviour-meaning">{meta.meaning}</p>

      <div className={`dxr-behaviour-callout ${isStrength ? 'good' : 'improve'}`}>
        <span className="dxr-callout-tag">{isStrength ? 'Strength' : 'Improve'}</span>
        <span className="dxr-callout-text">{isStrength ? meta.strong : meta.improve}</span>
      </div>
    </div>
  );
};

// Section 3 — Behaviour Insights. Own dedicated section; simple language, no formulas.
const BehaviourInsights = ({ metrics }) => {
  if (!metrics) return null;
  return (
    <div className="dxr-behaviour-grid">
      <BehaviourCard code="TPSI" metric={metrics.TPSI} />
      <BehaviourCard code="CER" metric={metrics.CER} />
      <BehaviourCard code="RCI" metric={metrics.RCI} />
      <BehaviourCard code="FFI" metric={metrics.FFI} />
    </div>
  );
};

export default BehaviourInsights;
